type JsonLdData = Record<string, unknown>;

/**
 * Renders one or more JSON-LD structured-data blocks. Pass a single schema
 * object or an array of them. Used for Article / BreadcrumbList / FAQPage /
 * Organization / WebSite markup that Google and LLM crawlers consume.
 */
export function JsonLd({ data }: { data: JsonLdData | JsonLdData[] }) {
  const blocks = Array.isArray(data) ? data : [data];
  return (
    <>
      {blocks.map((block, i) => (
        <script
          key={i}
          type="application/ld+json"
          // Schema is built from trusted, server-side content (no user input).
          dangerouslySetInnerHTML={{ __html: JSON.stringify(block) }}
        />
      ))}
    </>
  );
}
